import { render, staticRenderFns } from "./AutomaticPlannedLabel.vue?vue&type=template&id=2069ee20&scoped=true&"
import script from "./AutomaticPlannedLabel.vue?vue&type=script&lang=ts&"
export * from "./AutomaticPlannedLabel.vue?vue&type=script&lang=ts&"
import style0 from "./AutomaticPlannedLabel.vue?vue&type=style&index=0&id=2069ee20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2069ee20",
  null
  
)

export default component.exports